import { Box, Card, CardContent } from '@mui/material';

import { config } from '../libs/config';
import BrandMark from './BrandMark';

/**
 * Shared frame for the login and signout screens.
 *
 * The GHD deployment presents these as a centred card rather than the split panel with a
 * background image. That is the only way its screens differed - the sign-in logic itself was
 * identical, and its other difference (no "Sign in with Microsoft" button) is expressed by
 * REACT_APP_SSO_ENABLED, not by a separate component.
 *
 * So the layout is a config value rather than a second copy of each screen. Porting
 * login-ghd.js and signout-ghd.js as components would have duplicated the auth logic that
 * Phase 3 spent its effort unifying.
 *
 *   REACT_APP_AUTH_LAYOUT=split   default; background image on the left, form on the right
 *   REACT_APP_AUTH_LAYOUT=card    centred card, no background panel
 */
function AuthLayout({ children }) {
    if (config.authLayout === 'card') {
        return (
            <div className="login-container login-container--card">
                {/*
                  * The card sits over the artwork, same as the split layout's panel - the GHD
                  * screen this mirrors put the background on the container itself. Rendering
                  * the image layer in both branches keeps one mechanism rather than two.
                  */}
                <div className="login-left"></div>
                <Box component="form" className="login-box">
                    <Card sx={{ margin: '10px', boxShadow: 3 }}>
                        <CardContent>
                            {children}
                        </CardContent>
                    </Card>
                </Box>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-left"></div>
            <div className="login-right">
                <Box component="form" className="login-box">
                    {children}
                </Box>
            </div>
            {/*
              * Client mark over the artwork, bottom left. Both the login and signout screens
              * carry it, as they do on the MHAC branch. Hidden on short viewports by CSS
              * rather than a media-query hook, which is what the original used.
              */}
            <div className="login-mark">
                <BrandMark src="/branding/logo-white.svg" style={{ width: '350px' }} />
            </div>
        </div>
    );
}

export default AuthLayout;
